import { SvgIcon, SvgIconProps } from '@mui/material';

import colors from '../../constants/colors';

const InfoIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 24, height: 24, fill: 'none', ...props.sx }}
      data-testid="infoIcon"
      titleAccess="information"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM3.85484 12C3.85484 7.50155 7.50155 3.85484 12 3.85484C16.4984 3.85484 20.1452 7.50155 20.1452 12C20.1452 16.4984 16.4984 20.1452 12 20.1452C7.50155 20.1452 3.85484 16.4984 3.85484 12Z"
        fill={props.fill || colors.csaaLightBorder}
      />
      <path
        d="M12 9C12.8284 9 13.5 8.32843 13.5 7.5C13.5 6.67157 12.8284 6 12 6C11.1716 6 10.5 6.67157 10.5 7.5C10.5 8.32843 11.1716 9 12 9Z"
        fill={props.fill || colors.csaaLightBorder}
      />
      <path
        d="M12 11C11.1716 11 10.5 11.6716 10.5 12.5V16.5C10.5 17.3284 11.1716 18 12 18C12.8284 18 13.5 17.3284 13.5 16.5V12.5C13.5 11.6716 12.8284 11 12 11Z"
        fill={props.fill || colors.csaaLightBorder}
      />
    </SvgIcon>
  );
};

export default InfoIcon;
